<template>
  <b-overlay :show="$store.getters.loading" class="w-100 h-100"
    variant="dark" spinner-variant="light">
    <div class="parent" :class="[{white}, innerMode]">
      <div class="player" v-show="innerMode != 'n-player'" :class="[innerMode]">
        <div class="canvas" :class="[innerMode]">

          <canvas id="game"
            @mouseenter="showCtrlBar('display')"
            @mousemove="showCtrlBar('display')"
            @mouseleave="showCtrlBar(null)"></canvas>

          <div class="ctrl-bar" :class="[innerMode,ctrlBarVisible]">
            <div class="game-btn">
              <!-- <div v-if="innerMode != 'm-player'"
                class="mini-btn" @click="$emit('changeMode', innerMode = 'm-player')" >
                <b-icon icon="pip" variant="light" />
              </div> -->
              <div v-if="innerMode != 'l-player'"
                class="mini-btn" @click="$emit('changeMode', innerMode = 'l-player')" >
                <b-icon icon="square" variant="light" />
              </div>
              <div v-if="innerMode != 's-player'"
                class="mini-btn" @click="$emit('changeMode', innerMode = 's-player')" >
                <b-icon icon="tv" variant="light" />
              </div>
              <div v-if="innerMode != 'n-player'"
                class="mini-btn" @click="$emit('changeMode', innerMode = 'n-player')" >
                <b-icon icon="x" variant="light" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="innerDisplayLog"
        class="log" :class="[innerMode]">
        <div class="bg" v-if="innerMode != 's-player'" />
        <slot />
      </div>
      <div class="pocket-btn top-pocket-btn" v-if="innerMode == 'n-player'" @click="$emit('changeMode', innerMode = 'l-player')">
        <b-icon icon="box-arrow-in-down-left" variant="dark" />
      </div>
      <!-- <div class="pocket-btn top-pocket-btn" v-if="!innerDisplayLog" @click="$emit('displayLog', innerDisplayLog = true)">
        <b-icon icon="box-arrow-in-down-left" variant="dark" />
      </div> -->
    </div>
  </b-overlay>
</template>

<script>
import Loading from './mixin-loading'
import _ from 'lodash'
export default {
  props: {
    white: { type:Boolean, default:true },
    displayLog: { type:Boolean, default:true },
    mode: { type:String, default:'l-player' }
  },
  data () {
    return {
      innerMode: this.mode,
      innerDisplayLog: this.displayLog,
      ctrlBarVisible: null
    }
  },
  mixins: [
    Loading
  ],
  methods: {
    showCtrlBar (flg) {
      this.ctrlBarVisible = flg
      _.delay(()=>{ this.ctrlBarVisible = null }, 3000)
    }
  },
  watch: {
    mode (v) {
      this.innerMode = v
    },
    innerMode (v) {
      if((v == 'n-player' || v == 'm-player' || v == 'l-player') && !this.innerDisplayLog){
        this.$emit('displayLog', this.innerDisplayLog = true)
      }
      if((v == 's-player') && this.innerDisplayLog) {
        this.$emit('displayLog', this.innerDisplayLog = false)
      }
    },
    displayLog (v) {
      this.innerDisplayLog = v
      if(!v && (this.innerMode == 'l-player' || this.innerMode == 'n-player' || this.innerMode == 'm-player')){
        this.innerMode = 's-player'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.parent {
  display: flex;
  width: 100%;
  height: 100%;

  ::v-deep legend {
    // color: rgb(158, 45, 45);
    font-weight: bold;
  }
}
.player {
  width: calc(100% - 640px);
  height: calc(100% - 80px);

  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 300;

  background-color: #302330;
  // border: 1px solid #000;

  &.m-player, &.n-player {
    width: 500px;
    height: 300px;
    
    right: 10px;
    bottom: 0;
  }
  &.s-player {
    width: 90%;
    margin: 0 5%;
  }

  .canvas {
    width: 100%;

    position: relative;

    // border: 1px solid #0F0;
    // box-sizing: border-box;

    &.s-player {
      position: initial;
    }

    &:before {
      content: "";
      display: block;
      padding-top: 60%;
    }

    #game {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .ctrl-bar {
      width: 100%;
      height: 36px;

      position: absolute;
      bottom: 0;
      padding-top:3px;

      background-color: #000;
      color: #FFF;

      opacity: 0;
      transition: opacity .1s cubic-bezier(0.4,0.0,1,1);

      .game-btn {
        width: 95%;
        margin: 0 auto;

        display: flex;
        justify-content: flex-end;

        .mini-btn {
          margin-left: 10px;
          padding: 0 5px;
          width: 40px;
          cursor: pointer;

          svg { width: 30px; height: 30px; }
        }
      }

      &:hover,
      &.display {
        opacity: 1.0;
      }
    }

  }

}
.log {
  position: relative;
  width: 1000px;
  min-height: 100%;
  padding: 40px;

  margin-left: calc(100% - 640px);

  &.m-player, &.n-player{
    margin: 0 auto;
  }
  &.s-player {
    z-index: 400;
    pointer-events: none;
  }

  .bg {
    width: 100%;
    height: 100%;

    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    border-image: url('../assets/ui/frame1.png') 100;
    border-style:solid;
    border-width: 100px;
  }
}
.pocket-btn {
  width: 40px;
  height: 40px;

  position: fixed;
  cursor: pointer;

  svg { width:30px; height:30px; }

  &.bottom-pocket-btn {
    right: 10px;
    bottom: 10px;
  }
  &.top-pocket-btn {
    right: 10px;
    top: calc(10px + 80px);
  }
}
.white {
  background-color: #FFF;
}

@media (max-width: 1100px) {
  .parent {
    flex-direction: row;
  }
  .player.l-player {
    width: 100%;
    height: calc(50% - 80px);

    .canvas {
      height: 100%;

      &:before {
        padding-top: 0;
      }
    }
  }
  .log.l-player {
    height: 50%;
    width: 100%;
    margin: calc(50vh - 80px) 0 auto 0;
  }
}
@media (min-width: 1100px) {
  .player.s-player .canvas:before{
    padding-top: 600px;
  }
}
@media (min-width: 1640px) {
  .player .canvas:before{
    padding-top: 600px;
  }
}
@media (max-height: 680px) {
  .player.s-player .canvas {
    object-fit: contain;

    &:before{
      padding-top: initial;
      height: 100vh;
    }
  }
  
}
</style>